import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { Typography, Row, Col, Tabs, Input, Button } from "antd";
import { useHistory } from "react-router-dom";

import * as taxCollectionActions from "../../../../actionCreators/TaxCollection";
import * as dropDownActions from "../../../../actionCreators/DropDown";

import DataTable from "../../../../Components/DataTable";

import { addEllipsis } from "../../../../utils";
import "./style/surveyListing.css";
import "../../style/index.css";

const PaidProperties = ({
  getTaxCollectionsList,
  taxCollectionsList,
  navigation,
  handleSelectedData,
  getHighways,
  user,
  highways,
}) => {
  const history = useHistory();

  const [loading, setLoading] = React.useState(false);
  const [ownerName, setOwnerName] = useState("");
  const [searchedOwnerName, setSearchedOwnerName] = useState("");
  const [chosenFilters, setChosenFilters] = React.useState("");
  const [highwaysRes, setHighwaysRes] = useState([]);
  const [circles, setCircles] = useState([]);
  const [pagination, setPagination] = React.useState({
    page: 0,
    pageSize: 10,
    type: "challans",
  });
  const [rowData, setRowData] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [isInspector, setIsInspector] = React.useState(true);
  React.useEffect(() => {
    getTaxCollectionsList({
      page: 0,
      pageSize: 10,
      type: "challans",
    });
    getHighways();
    if (user) {
      let userCircles = user?.currentUser?.data?.circles;
      let temp = [];
      if (userCircles) {
        userCircles.map((data) => {
          let circle = {};
          circle["text"] = data?.name;
          circle["value"] = data?.id;
          temp.push(circle);
        });
        setCircles([...temp]);
      }
    }
  }, []);
  React.useEffect(() => {
    if (highways?.data) {
      let formattedHighways = highways?.data?.map((item) => {
        let obj = {};
        obj["text"] = `${item?.name}-${item?.code}`;
        obj["value"] = item?.id;
        return obj;
      });
      setHighwaysRes(formattedHighways);
    }
  }, [highways]);
  React.useEffect(() => {
    if (user) {
      setIsInspector(
        user.currentUser.data.user_roles.findIndex((e) => e.role_id == 1) >= 0
      );
    }
  }, [user]);
  React.useEffect(() => {
    if (taxCollectionsList?.data) {
      setPagination(taxCollectionsList.pagination);
      setLoading(taxCollectionsList.loading);
      setData(taxCollectionsList.data);
    }
  }, [taxCollectionsList]);

  const handleTablePageChange = (tableChangeData, filters) => {
    const { current, pageSize } = tableChangeData;
    const circleFilters = filters["property.circle"];
    const highwayFilters = filters["property.highway_name"];
    const status = filters["record.status"];
    let endFilter;
    if (!circleFilters?.length && !highwayFilters?.length && !status?.length) {
      endFilter = "";
    } else {
      endFilter = `circle=${circleFilters ? circleFilters : ""}+highway=${
        highwayFilters ? highwayFilters : ""
      }+status=${status ? status : ""}`;
    }
    setChosenFilters(endFilter);
    getTaxCollectionsList({
      page: current - 1,
      pageSize,
      type: "challans",
      filter: endFilter,
      owner: searchedOwnerName,
    });
  };

  const onSearched = () => {
    setSearchedOwnerName(ownerName);
    getTaxCollectionsList({
      page: 0,
      pageSize: 10,
      type: "challans",
      filter: chosenFilters,
      owner: ownerName,
    });
  };

  const tableColumns = [
    {
      title: "Serial No.",
      dataIndex: "serial_number",
      render: (serial_number) => (serial_number ? serial_number : "---"),
    },
    {
      title: "Owner Name",
      align: "center",
      dataIndex: ["property_data", "property_owners"],
      render: (property_owners) => {
        return addEllipsis(
          property_owners?.map((owner) => owner.name)?.join(",")
        );
      },
    },
    {
      title: "Circle",
      align: "center",
      dataIndex: ["property_data", "circle"],
      filters: circles,
      render: (circle) => (circle ? circle.name : "---"),
    },
    {
      title: "Highway",
      align: "center",
      filters: highwaysRes,
      dataIndex: ["property_data", "highway"],
      render: (highway) => (highway ? highway?.name : "---"),
    },
    {
      title: "PIN",
      align: "center",
      dataIndex: "serial_number",
      render: (pin) => (pin ? pin.slice(0, -6) : "---"),
    },
    {
      title: "ATV",
      align: "center",
      dataIndex: ["tax"],
      render: (atv) =>
        atv ? "RS. " + atv.annual_taxable_value?.toLocaleString() : "---",
    },
    {
      title: "Total Tax (5% of ATV)",
      align: "center",
      dataIndex: ["tax"],
      render: (tax) =>
        tax ? "RS. " + tax?.annual_tax?.toLocaleString() : "---",
    },
    {
      title: "Surcharge",
      align: "center",
      dataIndex: "surcharge",
      render: (tax) => tax?"RS. " + tax?.toLocaleString():0,
    },
    {
      title: "Arrears",
      align: "center",
      dataIndex: "arrears",
      render: (tax) => tax?"RS. " + tax?.toLocaleString():0,
    },
    {
      title: "Total Payable",
      align: "center",
      dataIndex: "total_tax",
      render: (tax) => (tax ? "RS. " + tax?.toLocaleString() : "---"),
    },
    {
      title: "Financial Year",
      align: "center",
      dataIndex: ["tax", "year"],
      render: (year) => year,
    },
    {
      title: "Issue Date",
      align: "center",
      dataIndex: "created_at",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "---"),
    },
    {
      title: "Due Date",
      align: "center",
      dataIndex: "due_date",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "---"),
    },
    {
      title: "Type",
      align: "center",
      filters: [
        {
          text: "Combined",
          value: "Combined",
        },
      ],
      onFilter: (data, row) => {
        if (data === row?.type) {
          return true;
        } else {
          return false;
        }
      },
      dataIndex: "type",
      render: (type) => (type ? type : "Combined"),
    },
    ...(isInspector
      ? [
          {
            title: "Request by TP",
            align: "center",
            dataIndex: "request_type",
            render: (data, row) => {
              if (isInspector) {
                if (data === "update_due_date") {
                  return <span>Update Due Date</span>;
                } else if (data === null) {
                  return <span>---</span>;
                }
              }
            },
          },
        ]
      : []),
    {
      title: "Status",
      align: "center",
      dataIndex: ["record", "status"],
      filters: [
        {
          text: "Paid",
          value: "PAID",
        },
        {
          text: "Unpaid",
          value: "UNPAID",
        },
        {
          text: "Expired",
          value: "EXPIRED",
        },
      ],
      // onFilter: (data, row) => {
      //   let date = new Date(row.due_date);
      //   let current_date = new Date();
      //   if (data === "PAID") {
      //     if (row.status == "PAID" && row.approval_status == "approved") {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   } else if (data === "expire") {
      //     if (
      //       current_date > date &&
      //       row.status == "UNPAID" &&
      //       row.approval_status == null
      //     ) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   } else if (data === "UNPAID") {
      //     if (
      //       (row.status == "UNPAID" || row.status == "PAID") &&
      //       row.approval_status == null
      //     ) {
      //       return true;
      //     } else {
      //       return false;
      //     }
      //   }
      // },
      render: (status, record) => {
        let date = new Date(record.due_date);
        let current_date = new Date();
        if (
          current_date > date &&
          record.status == "UNPAID" &&
          record.approval_status == null
        ) {
          return <span style={{ color: "red" }}>Expired</span>;
        } else if (
          record.status == "PAID" &&
          record.approval_status == "approved"
        ) {
          return <span style={{ color: "green" }}>Paid</span>;
        } else {
          return <span style={{ color: "orange" }}>Unpaid</span>;
        }
      },
    },
    {
      title: "Actions",
      dataIndex: ["record", "status"],
      render: (status, record) => {
        let date = new Date(record.due_date);
        let current_date = new Date();
        if (isInspector) {
          if (
            record.status === "PAID" &&
            record.approval_status === "approved"
          ) {
            return (
              <>
                <div
                  className="text-styling"
                  onClick={() => {
                    onTableRowClick(record);
                  }}
                >
                  View Receipt
                </div>
                <div
                  className="text-styling"
                  onClick={() => {
                    onViewProofClick(record);
                  }}
                >
                  View Proof of Payment
                </div>
              </>
            );
          }
          // else if (current_date > date) {
          //   return <span className="text-styling">Print Challan</span>;
          // }
          else {
            return (
              <ul
                // disabled={disabled}
                style={{
                  "list-style-type": "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                <li
                  className="text-styling"
                  onClick={() => {
                    onTableRowClickForPhTenForm(record);
                  }}
                >
                  <u>Print Challan</u>
                </li>
                <li
                  className="text-styling"
                  onClick={() => {
                    onTableRowClick(record);
                  }}
                >
                  <u>Update Receipt</u>
                </li>
              </ul>
            );
          }
        } else {
          return (
            <span
              className="text-styling"
              onClick={() => {
                onTableRowClickForPhTenForm(record);
              }}
            >
              Print Challan
            </span>
          );
        }
      },
    },
  ];

  const onTableRowClick = (data) => {
    taxCollectionActions.resetTaxCollection();
    setRowData(data);
    history.push("/tax-collection/view/" + data.id);
  };
  const onViewProofClick = (data) => {
    setRowData(data);
    history.push("/tax-collection/proof/" + data.id);
  };
  const onTableRowClickForPhTenForm = (data) => {
    taxCollectionActions.resetTaxCollection();
    setRowData(data);
    history.push("/tax-collection/viewform/" + data.id);
  };

  return (
    <>
      <Row>
        <Col span={22} style={{ marginRight: "1%" }}>
          <Input
            placeholder="Search Owner"
            value={ownerName}
            onPressEnter={onSearched}
            onChange={(e) => {
              setOwnerName(e.target.value);
            }}
          />
        </Col>
        <Col span={1}>
          <Button type="primary" onClick={onSearched}>
            Search
          </Button>
        </Col>
      </Row>
      <Row style={{ marginTop: "1%" }}>
        <DataTable
          rowClassName="table-row-cursor-pointer"
          columns={tableColumns}
          pagination={pagination}
          loading={loading}
          data={data}
          handleSelection={handleSelectedData}
          type={"paid"}
          handleTableValuesChange={handleTablePageChange}
          onRowClick={onTableRowClick}
          scroll={{ x: "max-content" }}
          selection={true}
        />
      </Row>
    </>
  );
};

const mapStateToProps = ({
  taxCollection: { taxCollectionsList },
  user,
  dropDown: { highways },
}) => ({ taxCollectionsList, user, highways });

const mapDispatchToProps = (dispatch) => ({
  getTaxCollectionsList: bindActionCreators(
    taxCollectionActions.getTaxCollectionsList,
    dispatch
  ),
  getHighways: bindActionCreators(dropDownActions.getHighways, dispatch),
});

PaidProperties.propTypes = {
  taxCollectionsList: PropTypes.object.isRequired,
  getTaxCollectionsList: PropTypes.func.isRequired,
  getHighways: PropTypes.func.isRequired,
  highways: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaidProperties);
